import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-six',
  templateUrl: './home-twenty-six.component.html',
  styleUrls: ['./home-twenty-six.component.scss']
})
export class HomeTwentySixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
